import { Redirect } from 'react-router-dom';
import type { match } from 'react-router';
import urlJoin from 'url-join';

import adminPage from 'hocs/admin-page';
import type { PropsMapper } from 'hocs/admin-page';

import TemplateGroups from './template-groups';
import ApiTokens from './api-tokens';
import Webhooks from './webhooks';

type Props = {
  match: match,
};

export const WorkflowsPage = (props: Props) => {
  return (
    <Redirect from={props.match.path} to={urlJoin(props.match.url, '/template-groups')} />
  );
};

type MapperProps = {
  message: (args: { id: string; comment?: string }) => string;
};

export const propsMapper: PropsMapper = ({ props }: { props: MapperProps }) => ({
  title: props.message({
    id: 'Workflows',
    comment: 'The page title',
  }),
  showAsLink: false,
  modules: [[
    {
      component: TemplateGroups,
      hideBreadCrumb: true,
      path: '/template-groups',
      section: props.message({ id: 'Workflows', comment: 'Used as the title for the section.' }),
      title: props.message({ id: 'Template groups', comment: 'Page title for the workflows page.' }),
    },
    {
      component: ApiTokens,
      hideBreadCrumb: true,
      path: '/api-tokens',
      section: props.message({ id: 'Workflows', comment: 'Used as the title for the section.' }),
      title: props.message({ id: 'API tokens', comment: 'Page title for the workflows page.' }),
    },
    {
      component: Webhooks,
      hideBreadCrumb: true,
      path: '/webhooks',
      section: props.message({ id: 'Workflows', comment: 'Used as the title for the section.' }),
      title: props.message({ id: 'Webhooks', comment: 'Page title for the workflows page.' }),
    }
  ]],
});

export default adminPage(propsMapper)(WorkflowsPage);
